import React from 'react';
import PropTypes from 'prop-types';

const PopupCloseIcon = ({ width, onClick }) => (
  <span
    role="none"
    className="icon-close"
    onClick={onClick}
    style={{ fontSize: width, color: '#989898' }}
  />
);

PopupCloseIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
};

PopupCloseIcon.defaultProps = {
  width: 22,
  onClick: () => {},
};

export default PopupCloseIcon;
